import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row" }
const _hoisted_2 = { class: "sm:w-1/2" }
const _hoisted_3 = { class: "m-auto pt-30 px-20 max-w-750 sm:pt-0 sm:w-1/2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

import { PropType } from 'vue';
import { HighlightTileModel } from '@/types/B2BcontentServerContract';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightTile',
  props: {
    content: {
        type: Object as PropType<HighlightTileModel>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MediaHandler, {
          "media-aspect-ratio": {'default': 1/1},
          "media-block": __props.content.media,
          "image-width-on-screen": {
                                  xs: 100,
                                  sm: 50,
                              },
          "video-autoplay-override": __props.content.autoPlay,
          "media-tile-content-block": __props.content
        }, null, 8, ["media-block", "video-autoplay-override", "media-tile-content-block"])
      ]),
      _createElementVNode("article", _hoisted_3, [
        (__props.content.subheading)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "o-text-caption uppercase m-0",
              innerHTML: __props.content.subheading
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (__props.content.title)
          ? (_openBlock(), _createElementBlock("h2", {
              key: 1,
              class: "mb-30",
              innerHTML: __props.content.title
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (__props.content.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "my-10",
              innerHTML: __props.content.text
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (__props.content.link)
          ? (_openBlock(), _createBlock(CMSLinkHandler, {
              key: 3,
              "link-block": __props.content.link,
              "style-as-button": true,
              class: "mt-15"
            }, null, 8, ["link-block"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})